import { WifiOff, RefreshCw } from 'lucide-react';
import { cn } from '@/lib/utils';

interface OfflineIndicatorProps {
  isOnline: boolean;
  pendingCount: number;
}

export function OfflineIndicator({ isOnline, pendingCount }: OfflineIndicatorProps) {
  if (isOnline && pendingCount === 0) return null;

  if (!isOnline) {
    return (
      <div className={cn(
        'flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium',
        'bg-yellow-500/15 text-yellow-600 dark:text-yellow-400 border border-yellow-500/20'
      )}>
        <WifiOff className="w-3 h-3" />
        <span className="hidden sm:inline">Offline</span>
      </div>
    );
  }

  // Online but pending sync
  return (
    <div className={cn(
      'flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium',
      'bg-blue-500/15 text-blue-600 dark:text-blue-400 border border-blue-500/20'
    )}>
      <RefreshCw className="w-3 h-3 animate-spin" />
      <span className="hidden sm:inline">{pendingCount} ausstehend</span>
    </div>
  );
}
